import { type FlagConfiguration, useFlagsService } from '@atlassian/jira-flags';
import { useIntl } from '@atlassian/jira-intl';
import { type MenuNode, MenuNodeType } from '@atlassian/jira-software-context-menu';
import { COPY_ISSUE_LINK_MENU_ID } from '../../constants';
import messages from './messages';
import type { ContentProps, Props } from './types';

const copySuccessfulFlagConfiguration: FlagConfiguration = {
	type: 'success',
	title: messages.copySuccessTitle,
	description: messages.copySuccessMessage,
};

const copyFailureFlagConfiguration: FlagConfiguration = {
	type: 'error',
	title: messages.copyFailureTitle,
	description: messages.copyFailureMessage,
};

export const useCopyIssueLinkContent = ({
	isCopyLinkVisible,
	onCopyIssueLink,
}: ContentProps): MenuNode[] => {
	const { formatMessage } = useIntl();

	if (!isCopyLinkVisible) return [];

	return [
		{
			type: MenuNodeType.Item,
			label: formatMessage(messages.copyIssueLink),
			id: COPY_ISSUE_LINK_MENU_ID,
			onClick: onCopyIssueLink,
		},
	];
};

export const useCopyIssueLink = ({ isMultiSelectMode, issueKey }: Props) => {
	const { showFlag } = useFlagsService();

	const onCopyIssueLink = async () => {
		const issueUrl = `${window.location.protocol}//${window.location.hostname}/browse/${issueKey}`;
		try {
			await navigator.clipboard.writeText(issueUrl);
			showFlag(copySuccessfulFlagConfiguration);
		} catch (err) {
			showFlag(copyFailureFlagConfiguration);
		}
	};

	return useCopyIssueLinkContent({
		isCopyLinkVisible: !isMultiSelectMode,
		onCopyIssueLink,
	});
};
